import React from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { PURCHASE_EVENT_STATUS } from '@enums';
import { Button, Typography } from '@ui';
import { Col, Flex } from 'antd';
import { StyledAlert, StyledStoreUrl } from './styled';

const THEME_EXTENSION_CONNECTED = 'CONNECTED';

const ConnectedPlatform = ({
    platformName,
    domainSuffix,
    trimmedDomain,
    isValid,
    updateScopes,
    setupInfo,
    dataTestIdPrefix
}) => {
    const themeExtension = setupInfo.themeExtension;
    const hasThemeExtension = !!themeExtension;
    const themeConnected = !hasThemeExtension || themeExtension.status === THEME_EXTENSION_CONNECTED;
    const purchaseEventConnected = setupInfo.purchaseEventStatus === PURCHASE_EVENT_STATUS.CONNECTED;

    const missingSetups = [
        hasThemeExtension && !themeConnected && 'Theme extension setup',
        !purchaseEventConnected && 'Purchase events setup'
    ]
        .filter(Boolean)
        .join(', ');

    const renderConnectionStatus = () => {
        if (isValid && purchaseEventConnected && themeConnected) {
            return (
                <Typography.Text align='center' color={COLORS.$robinBlue} type='descriptor1'>
                    {platformName} connection is up to date.
                </Typography.Text>
            );
        }

        if (!isValid) {
            return (
                <Flex justify='space-between' align='center'>
                    <Typography.Text color={COLORS.$tartRed} type='descriptor1'>
                        App update required for your {platformName} integration
                    </Typography.Text>
                    <Button
                        data-e2e={`integrations_update-${dataTestIdPrefix}-connection_btn`}
                        style={{ width: 200 }}
                        block
                        type='primary'
                        onClick={updateScopes}
                    >
                        Update Integration
                    </Button>
                </Flex>
            );
        }

        if ((isValid && !themeConnected) || !purchaseEventConnected) {
            return (
                <Flex justify='center' align='center'>
                    <Typography.Text align='center' color={COLORS.$tartRed} type='descriptor1'>
                        {platformName} connection requires {missingSetups}
                    </Typography.Text>
                </Flex>
            );
        }

        return null;
    };

    return (
        <div style={BOTTOM_INDENTS.M}>
            <StyledStoreUrl align='middle' justify='space-between' wrap={false}>
                <Col>
                    <Typography.Text
                        data-e2e={`integrations_connected-${dataTestIdPrefix}-domain_value`}
                        type='descriptor1'
                    >
                        {trimmedDomain}
                    </Typography.Text>
                </Col>
                <Col>
                    <Typography.Text type='descriptor1' color={COLORS.$gray40Black}>
                        {domainSuffix}
                    </Typography.Text>
                </Col>
            </StyledStoreUrl>
            <StyledAlert
                data-e2e={`integrations_${dataTestIdPrefix}-connection-status_block`}
                $isValid={isValid && purchaseEventConnected && themeConnected}
            >
                {renderConnectionStatus()}
            </StyledAlert>
        </div>
    );
};

export default ConnectedPlatform;
